import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ZorroTableComponent } from "../../common/custom-table/zorro-table.component";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";

@Component({
  selector: "app-web-script-modal",
  standalone: true,
  imports: [ZorroTableComponent, CommonModule, DynamicFormComponent],
  templateUrl: "./web-script-modal.component.html",
  styleUrl: "./web-script-modal.component.scss",
})
export class WebScriptModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  isActive:boolean = false;
  selectedDevice: any = null;

  @Input() configs: any = {};

  ngOnInit(): void {
    console.log("Received configs in WebScriptModalComponent:", this.configs);
    this.addNewRow();
  }

  addNewRow() {
    const newRow = {
      id: Date.now().toString(),
      role: '',
      username: '',
      password: '',
      remarks: '',
      isRowEditable: true,
      isDraft: true
    };
    this.configs.tableData.rows = [newRow, ...this.configs.tableData.rows];
  }

  create() {
    if (this.dynamicForm.valid) {
      const formValue = this.dynamicForm.value;
      const credentials = this.configs.tableData.rows.filter((row: any) => !row.isDraft);
      
      // If device is selected, include device name
      const result: any = { ...formValue, credentials };
      if (this.selectedDevice && formValue.device) {
        result.deviceName = this.selectedDevice.label || this.selectedDevice.name || this.selectedDevice.deviceName;
      }
      
      this.activeModal.close(result);
    }
  }

  onFormChange(event: any) {
    // Track device selection
    if (event.field?.key === 'device') {
      // Find the device field from the configs
      const deviceField = this.configs.fields?.find((f: any) => f.key === 'device');
      if (deviceField && deviceField.options) {
        this.selectedDevice = deviceField.options.find((opt: any) => opt.value === event.value);
      }
    }
  }

  handleTableActions(event: any) {
    const { actionType, data } = event;
    const row = data?.row;
    const rowIndex = this.configs.tableData.rows.findIndex((r: any) => r.id === row?.id);
    
    if (rowIndex === -1) return;
    
    switch (actionType) {
      case 'edit':
        // Store original data for potential cancel
        this.configs.tableData.rows[rowIndex]._originalData = { ...this.configs.tableData.rows[rowIndex] };
        // Enable editing for this row - mutate existing object to preserve ngModel binding
        this.configs.tableData.rows[rowIndex].isRowEditable = true;
        // Force update by creating new array reference to trigger change detection
        this.configs.tableData.rows = [...this.configs.tableData.rows];
        break;
        
      case 'add':
        // Replace the row with the updated row from the event
        this.configs.tableData.rows[rowIndex] = row;
        this.configs.tableData.rows[rowIndex].isRowEditable = false;
        this.configs.tableData.rows[rowIndex].isDraft = false;
        
        // Remove the backup
        delete this.configs.tableData.rows[rowIndex]._originalData;
         
        // Force update by creating new array reference
        this.configs.tableData.rows = [...this.configs.tableData.rows];
        break;
        
      case 'cancel':
        if (this.configs.tableData.rows[rowIndex].isDraft) {
          // Remove draft row
          this.configs.tableData.rows.splice(rowIndex, 1);
        } else {
          // Restore original data
          const restoredRow: any = {};
          if (this.configs.tableData.rows[rowIndex]._originalData) {
            const originalData = this.configs.tableData.rows[rowIndex]._originalData;
            Object.keys(originalData).forEach(key => {
              if (key !== '_originalData') {
                restoredRow[key] = originalData[key];
              }
            });
          }
          // Cancel edit - revert to view only
          restoredRow.isRowEditable = false;
          this.configs.tableData.rows[rowIndex] = restoredRow;
        }
        break;
        
      case 'delete':
        this.configs.tableData.rows.splice(rowIndex, 1);
        this.configs.tableData.rows = [...this.configs.tableData.rows];
        break;
    }
  }
}
